import {defineStore, } from 'pinia'

export const usePageTransitionStore = defineStore('page-transition', {
    state () {
        return {
            transitioning: false,
        }
    },
})
